export const getFormatColumnSettingsViewItems = (formatColumn) => {
    var _a, _b, _c, _d;
    const values = [
        `Cell alignment: ${(_a = formatColumn.CellAlignment) !== null && _a !== void 0 ? _a : 'default'}`,
        `Data Rows: ${((_b = formatColumn.RowScope) === null || _b === void 0 ? void 0 : _b.ExcludeDataRows) ? 'Yes' : 'No'}`,
        `Group Rows: ${((_c = formatColumn.RowScope) === null || _c === void 0 ? void 0 : _c.ExcludeGroupRows) ? 'Yes' : 'No'}`,
        `Row Summaries: ${((_d = formatColumn.RowScope) === null || _d === void 0 ? void 0 : _d.ExcludeSummaryRows) ? 'Yes' : 'No'}`,
    ].filter(Boolean);
    return {
        name: 'Settings',
        values,
    };
};
